$( document ).ready(function() {
    $('.full-width-app.subscriptionPage.subscriptionSlick .packageHeader .packageName').each(function () {
        var contents = $(this).html(),
            indexOfSep = contents.indexOf('+') - 1;

        if (indexOfSep > -1) {
            var newContents = contents.slice(0, indexOfSep) + '<div class="packageNameSubtext">' + contents.slice(indexOfSep);
            newContents = newContents + '</div>';
            $(this).html(newContents);
        }
    });
});
